import { reactive } from 'vue'

// Beställningens datamodell och delade, reaktiva tillstånd.
//
// Stegkomponenterna skriver hit direkt istället för att mutera props –
// formuläret är en enda sammanhängande beställning, och att skicka varje
// fält upp och ner genom tre komponentlager ger bara brus.

// Reglerna för vad en beställning får innehålla bor här, inte i komponenterna,
// så att Benders kan justera dem på ett ställe.

// Utloppet ligger på items[0], så items rymmer MAX_INLETS + 1 poster.
export const MAX_INLETS = 15
export const MAX_WELLS = 50
export const RORTYP_OPTIONS = [
  'Betong',
  'Slät plast (PP/PVC)',
  'Ultra rib 2',
  'Pragma',
  'Ej listat fabrikat/material',
]

// Fältordningen här speglas i wellFields i @/formFields.js – håll dem i synk.
export function newForm() {
  return {
    littera: '',
    outflowHeight: '',
    finishedHeight: '',
    dimension: '',
    vallning: '',
    betackning: '',
    items: [
      {
        anslutning: 'Utlopp',
        dimension: '',
        rortyp: '',
        vinkel: '0',
        stalp: '',
        sandfang: '',
      },
    ],
  }
}

// 'YYYY-MM-DD' → true för lördag/söndag. Datumet byggs komponentvis;
// new Date('2026-08-15') tolkas som UTC och kan hamna på fel dag.
export function isWeekend(value) {
  if (!value) return false
  const [y, m, d] = value.split('-').map(Number)
  if (!y || !m || !d) return false
  const day = new Date(y, m - 1, d).getDay()
  return day === 0 || day === 6
}

// Obligatoriska kunduppgifter – en enda lista som både fältvalideringen och
// stegspärren utgår från. `path` är samma nyckel som validateField skriver i
// validationErrors, så StepCustomer behöver ingen egen uppräkning.
const REQUIRED_CUSTOMER_FIELDS = [
  { path: 'common.place', value: (s) => s.common.place },
  { path: 'customer.firstName', value: (s) => s.customer.firstName },
  { path: 'customer.phone', value: (s) => s.customer.phone },
  { path: 'customer.lastName', value: (s) => s.customer.lastName },
  { path: 'customer.deliveryDate', value: (s) => s.customer.deliveryDate },
]

export const store = reactive({
  customer: {
    firstName: '',
    lastName: '',
    number: '',
    phone: '',
    deliveryDate: '',
    information: '',
  },
  common: {
    place: '',
    date: new Date().toISOString().slice(0, 10),
  },
  wellCount: 0,
  forms: [],
  collapsedStates: [],
  validationErrors: {},

  // Steg 0 är komplett när alla obligatoriska fält är ifyllda och
  // leveransdatumet är en vardag – samma två regler som validateField.
  get customerValid() {
    return (
      REQUIRED_CUSTOMER_FIELDS.every((f) => (f.value(this) || '').trim() !== '') &&
      !isWeekend(this.customer.deliveryDate)
    )
  },

  // Steg 1 är komplett när det finns minst en brunn och alla har littera.
  get wellsValid() {
    return this.forms.length > 0 && this.forms.every((f) => (f.littera || '').trim() !== '')
  },

  // Synka antalet brunnar med antalet ifyllda formulär.
  setWellCount(newCount) {
    this.wellCount = newCount
    const oldCount = this.forms.length
    if (newCount > oldCount) {
      for (let i = oldCount; i < newCount; i++) {
        this.forms.push(newForm())
        this.collapsedStates.push(false)
      }
    } else {
      this.forms.splice(newCount)
      this.collapsedStates.splice(newCount)
    }
  },

  removeWell(index) {
    this.forms.splice(index, 1)
    this.collapsedStates.splice(index, 1)
    this.wellCount = this.forms.length
  },

  toggleCollapsed(index) {
    this.collapsedStates[index] = !this.collapsedStates[index]
  },

  validateField(field, value) {
    const empty = !value || value.trim() === ''
    // Leverans sker bara på vardagar – helgval markeras som fel.
    const weekend = field === 'customer.deliveryDate' && isWeekend(value)
    if (empty || weekend) {
      this.validationErrors[field] = true
    } else {
      delete this.validationErrors[field]
    }
  },
})
